<template>
  <div class="w-full h-full">
<woot-modal :show.sync="show" :on-close="onClose">
  <woot-modal-header
    :header-title="'Have you taken the follow up?'"
  />
  
  <div class="flex justify-end gap-4 p-6">
    <woot-button variant="smooth" color-scheme="primary" @click="handleFollowUp('yes')">
      Yes
    </woot-button>
    <woot-button variant="clear" color-scheme="secondary" @click="handleFollowUp('no')">
      No
    </woot-button>
  </div>
</woot-modal>
</div>
</template>


<script>
import alertMixin from 'shared/mixins/alertMixin';
export default {
  props: {
    primaryContact: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [alertMixin],
methods: {
    onClose() {
      this.$emit('close');
    },
     async  handleFollowUp(response) {
        
       let data = response === 'yes' ? {
           isReaded: true
        }:{
            isReaded:false
        }

     const responses = await this.$store.dispatch('contacts/demo_mark_read', {
              contactId:this.primaryContact.id,
              data: data,
            });
            console.log(responses.data,responses, "this is the dat")
       
       if(responses?.success){
        this.showAlert('Reminder mark as done', {success: true});
        this.primaryContact.additional_attributes.calendar_timings= null
        }else{
        this.showAlert('Reminder mark as pending', {success: false});
       }

      this.$emit('success-message');
      this.onClose();
    },
}
}
  </script>